import React, { useEffect, useState } from "react";
import { getTopViewedLink, getRecentlyAddedLink } from "./Network_Calls";
import { useParams, useNavigate } from "react-router-dom";
import classes from "./Search.module.css";
import Navbar from "../Navbar/Navbar";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { linkVisitHistoryUpdate } from "../Dossier/Network_call";
import {
  createColumnHelper,
  flexRender,
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  getPaginationRowModel,
} from "@tanstack/react-table";

const MostViewedTopLink = () => {
  const { implId, journey_type, selecttype } = useParams();
  const [spinner, setSpinner] = useState(false);
  const [most_viewed, setMostViewed] = useState([]);

  console.log("params in most viewed", implId, journey_type, selecttype);

  const navigate = useNavigate();

  useEffect(() => {
    (async function () {
      setMostViewed(null);
      setSpinner(true);

      if (selecttype === "recentlyAdded") {
        const result = await getRecentlyAddedLink(implId, journey_type);
        console.log("result of recent", result )
        if (result.status === 200) {
          const data = result.data.recentlyAddedLinks.slice(0, 25);
          setMostViewed(data);
          setSpinner(false);
        } else {
          setSpinner(false);
        } 
      } else {
        const result = await getTopViewedLink(implId, journey_type);
        if (result.status === 200) {
          const data = result.data.topViewedLinks.slice(0, 25);
          setMostViewed(data);
          setSpinner(false);
        } else {
          setSpinner(false);
        }
      }
    })();
  }, [implId, journey_type, selecttype]);

  const handleLinkClick = async (index) => {
    try {
      const response = await linkVisitHistoryUpdate(index);
      if (response.status === 200) {
        setMostViewed((prevState) =>
          prevState.map((link) =>
            link.link_id === index
              ? { ...link, views: parseInt(link.views, 10) + 1 }
              : link
          )
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.accessor("name", {
      header: "Link Name",
      cell: (info) => (
        <span style={{ fontSize: "1rem", color: "#000" }}>
          {info.getValue()}
        </span>
      ),
    }),
    columnHelper.accessor("links", {
      header: "URL",
      cell: (info) => (
        <a
          href={info.getValue()}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => handleLinkClick(info.row.original.link_id)}
          style={{ color: "#000" }}
        >
          {info.row.original.link_name}
        </a>
      ),
    }),
    /* columnHelper.accessor("views", {
      header: "Views",
      cell: (info) => (
        <span>
          {" "}
          <span style={{ fontSize: "1.5rem", color: "#1FAFC2" }}>
            {info.getValue()}
          </span>{" "}
          <span style={{ color: " #FF762B" }}>views </span>{" "}
        </span>
      ),
    }), */
    ...(selecttype === "recentlyAdded"
      ? [
          columnHelper.accessor("created_at", {
            header: "Created At",
            cell: (info) => (
              <span style={{ fontSize: "1rem", color: "#000" }}>
                {new Date(info.getValue()).toLocaleDateString("en-US")}
              </span>
            ),
          }),
        ]
      : [
          columnHelper.accessor("views", {
            header: "Views",
            cell: (info) => (
              <span>
                <span style={{ fontSize: "1.5rem", color: "#1FAFC2" }}>
                  {info.getValue()}
                </span>{" "}
                <span style={{ color: " #FF762B" }}>views </span>
              </span>
            ),
          }),
        ]),
    columnHelper.accessor("link_tags", {
      header: "Tags",
      cell: (info) => (
        <div className="flex gap-2">
          {Object.values(info.getValue()).map((tag, tagIndex) =>
            tag !== "Null" ? (
              <div
                key={tagIndex}
                style={{
                  border: "0.1rem solid #1FAFC2",
                  backgroundColor: "#BCE4E9",
                  borderRadius: "0.2rem",
                  padding: "0.3rem",
                  display: "flex",
                  justifyContent: "center",
                  maxWidth: "fit-content",
                  margin: "0.5rem",
                }}
              >
                <span>{tag}</span>
              </div>
            ) : (
              <div style={{ margin: "0.5rem" }}>-</div>
            )
          )}
        </div>
      ),
    }),
  ];

  const table = useReactTable({
    data: most_viewed ?? [],
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    initialState: {
      pagination: { pageSize: 5 },
    },
  });

  return (
    <div>
      <Navbar />
      <div style={{ padding: "30px" }}>
        <Button onClick={() => navigate(-1)} variant="contained">
          Go back
        </Button>
      </div>
      {spinner ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <div>
            <h5
              className={classes.mostviewed_banner}
              style={{ fontSize: "2rem", marginBottom: "2rem" }}
            >
              Most Viewed Links
            </h5>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "2rem",
              alignItems: "center",
            }}
          >
            <div style={{ width: "70%", margin: "0 auto" }}>
              <div
                style={{ backgroundColor: " #1FAFC2", borderRadius: "0.2rem" }}
              >
                {table.getHeaderGroups().map((headerGroup) => (
                  <div key={headerGroup.id} style={{ display: "flex" }}>
                    {headerGroup.headers.map((header) => (
                      <div
                        key={header.id}
                        style={{
                          width: "25%",
                          padding: "1rem",
                          borderLeft: "0.1rem solid #fff",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "1rem",
                            textAlign: "left",
                            color: " #fff",
                            fontWeight: "bold",
                          }}
                        >
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
              <div style={{ backgroundColor: "#F7F1F1" }}>
                {table.getRowModel().rows.map((row) => (
                  <div key={row.id} style={{ display: "flex" }}>
                    {row.getVisibleCells().map((cell) => (
                      <div
                        key={cell.id}
                        style={{
                          width: "25%",
                          padding: "1rem",
                          border: "0.1rem solid #DCD8D5",
                        }}
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "70%",
                marginBottom:"2rem"
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label style={{ Color: "#000" }}>Items per page: </label>
                <select
                  style={{
                    padding: "8px 12px",
                    fontSize: "16px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    backgroundColor: "#f9f9f9",
                    color: "#333",
                    cursor: "pointer",
                  }}
                  value={table.getState().pagination.pageSize}
                  onChange={(e) => table.setPageSize(Number(e.target.value))}
                >
                  {[5, 10, 15, 20].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      {pageSize}
                    </option>
                  ))}
                </select>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <button
                  onClick={() => table.setPageIndex(0)}
                  disabled={!table.getCanPreviousPage()}
                  style={{
                    padding: "8px 12px",
                    fontSize: "14px",
                    backgroundColor: "#f9f9f9",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    cursor: table.getCanPreviousPage()
                      ? "pointer"
                      : "not-allowed",
                    opacity: table.getCanPreviousPage() ? 1 : 0.5,
                  }}
                >
                  {"<<"}
                </button>
                <button
                  onClick={() => table.previousPage()}
                  disabled={!table.getCanPreviousPage()}
                  style={{
                    padding: "8px 12px",
                    fontSize: "14px",
                    backgroundColor: "#f9f9f9",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    cursor: table.getCanPreviousPage()
                      ? "pointer"
                      : "not-allowed",
                    opacity: table.getCanPreviousPage() ? 1 : 0.5,
                  }}
                >
                  {"<"}
                </button>
                <span
                  style={{
                    fontSize: "16px",
                    color: "#333",
                  }}
                >
                  {table.getState().pagination.pageIndex + 1} of{" "}
                  {table.getPageCount()}
                </span>
                <button
                  onClick={() => table.nextPage()}
                  disabled={!table.getCanNextPage()}
                  style={{
                    padding: "8px 12px",
                    fontSize: "14px",
                    backgroundColor: "#f9f9f9",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    cursor: table.getCanNextPage() ? "pointer" : "not-allowed",
                    opacity: table.getCanNextPage() ? 1 : 0.5,
                  }}
                >
                  {">"}
                </button>
                <button
                  onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                  disabled={!table.getCanNextPage()}
                  style={{
                    padding: "8px 12px",
                    fontSize: "14px",
                    backgroundColor: "#f9f9f9",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    cursor: table.getCanNextPage() ? "pointer" : "not-allowed",
                    opacity: table.getCanNextPage() ? 1 : 0.5,
                  }}
                >
                  {">>"}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default MostViewedTopLink;
